import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSignalTriggersQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetSignalTriggersQuery = {
  __typename?: 'Query';
  signal?: {
    __typename?: 'Signal';
    id: any;
    name: string;
    triggers: {
      __typename?: 'SignalTriggerConnection';
      totalCount: number;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        endCursor?: string | null;
      };
      edges: Array<{
        __typename?: 'SignalTriggerEdge';
        node: {
          __typename?: 'SignalTrigger';
          id: any;
          triggeredAt: any;
          transaction?: {
            __typename?: 'Transaction';
            hash: string;
            blockNumber?: number | null;
            value: Array<number>;
            from: { __typename?: 'Address'; address: string };
            to?: { __typename?: 'Address'; address: string } | null;
          } | null;
        };
      }>;
    };
  } | null;
};

export const GetSignalTriggersDocument = gql`
  query GetSignalTriggers($id: UUID!, $first: Int, $after: String) {
    signal(id: $id) {
      id
      name
      triggers(first: $first, after: $after) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            triggeredAt
            transaction {
              hash
              blockNumber
              from {
                address
              }
              to {
                address
              }
              value
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetSignalTriggersQuery__
 *
 * To run a query within a React component, call `useGetSignalTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignalTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignalTriggersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetSignalTriggersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSignalTriggersQuery,
    GetSignalTriggersQueryVariables
  > &
    (
      | { variables: GetSignalTriggersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSignalTriggersQuery,
    GetSignalTriggersQueryVariables
  >(GetSignalTriggersDocument, options);
}
export function useGetSignalTriggersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSignalTriggersQuery,
    GetSignalTriggersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSignalTriggersQuery,
    GetSignalTriggersQueryVariables
  >(GetSignalTriggersDocument, options);
}
export function useGetSignalTriggersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSignalTriggersQuery,
        GetSignalTriggersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSignalTriggersQuery,
    GetSignalTriggersQueryVariables
  >(GetSignalTriggersDocument, options);
}
export type GetSignalTriggersQueryHookResult = ReturnType<
  typeof useGetSignalTriggersQuery
>;
export type GetSignalTriggersLazyQueryHookResult = ReturnType<
  typeof useGetSignalTriggersLazyQuery
>;
export type GetSignalTriggersSuspenseQueryHookResult = ReturnType<
  typeof useGetSignalTriggersSuspenseQuery
>;
export type GetSignalTriggersQueryResult = Apollo.QueryResult<
  GetSignalTriggersQuery,
  GetSignalTriggersQueryVariables
>;
